import { useEffect, useState } from 'react';

// Ensure that elli is declared globally
declare const elli: any;
const MAX_RETRIES = 3;
const RETRY_DELAY = 1000;
export const useElliData = () => {
  const [loanId, setLoanId] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [authCode, setAuthCode] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const dispatchInputEvent = (id: string, message: string | null) => {
    const errorField = document.getElementById(id);
    // @ts-ignore
    errorField.value = message;
    // @ts-ignore
    errorField.dispatchEvent(new Event('input'));
  }

  useEffect(() => {
    const initializeElliScript = async (retryCount=0) => {
      try {
        // Check if elli is defined
        if (typeof elli === 'undefined') {
          throw new Error('Elli is not defined');
        }

        // Initialize elli script
        elli.script.guest.create();
        console.log(elli.script.getObject("tpoApplication"),"tpoAppElii");
        const tpoAppObject = await elli.script.getObject("tpoApplication");
        console.log('tpoAppObject:', tpoAppObject);

        // Retrieve user data
        const userData = await tpoAppObject.getUserData();


        const loanData = await tpoAppObject.getLoanData();
        setLoanId(loanData.EncompassId);
        localStorage.setItem("loan_id", loanData.EncompassId || "error")
        console.log(loanData,"loanData");
        // Create auth code
        const authCodeValue = await tpoAppObject.createAuthCode("3c5hwwa8", 1);

        // Retrieve loan data
        setTimeout(() => {
          setUserId(userData.contactID);
          localStorage.setItem("user_id", userData.contactID || "error")
          dispatchInputEvent('user', userData.contactID);
          console.log(userData,"userData");
          setAuthCode(authCodeValue);
          localStorage.setItem("auth_code", authCodeValue || "error")
          dispatchInputEvent('authCode', authCodeValue);
          console.log(authCodeValue,"authCodeValue");

        }, 2000);
      } catch (err) {
        if (retryCount < MAX_RETRIES) {
          console.error(`Error occurred, retrying... (${retryCount + 1}/${MAX_RETRIES})`, err);
          setTimeout(() => initializeElliScript(retryCount + 1), RETRY_DELAY);
        } else {
          setError('Failed to initialize Elli script or retrieve data.');
          console.error('Max retries reached. Error:', err);
        }
      } finally {
        console.log("Initialization complete");
      }
    };

    initializeElliScript().then(r => {
      console.log('Initialization result:', r);
    });
  }, []);

  return { loanId, userId, authCode, error };
};
